export default __webpack_public_path__ + "static/media/3.4ed8e6c3.jpg";